/* eslint-disable no-new */
import * as types from './mutation-define'
import {selectoption} from "@/api/module/select_options"    

const options_array = [
    'products_filter',
    'sysuser'
]

const default_value = {
}


const state = function() {
    let out_state = {};

    options_array.map(op => {
        out_state[`select_${op}_options`] = default_value[op] ? default_value[op] : [];
    })
    return out_state
}()


// getters
const getters = function() {
    let out_obj = {
        
    };
    options_array.map(op => {
        out_obj[`select_${op}_options`] = state => state[`select_${op}_options`];
    })

    return out_obj
}()

const actions = {
    select_option_update(context, { oper, query={},callback }) {

        // let query = {oper:'shop',key:"_id",value:"cn_name",type:'obj',skipp:'shop_id'}
        query.oper = oper;

        let op_type = `select_${oper}_options`;
        // debugger
        if(state[op_type].length) return Promise.resolve(state[op_type]);
        if(!state[op_type]) return Promise.reject("not configed selectoption");
        return selectoption(query).then(resp=>{
            state[op_type] = resp.data;
            context.commit(`SELECT_OPTION_${oper.toUpperCase()}`,resp.data)
            return resp.data;
        }).catch(err=>{
            console.log(err);
            debugger
        })
    }
}

const mutations = function() {
    let out_obj = {};

    options_array.map(op => {
        let name = `SELECT_OPTION_${op.toUpperCase()}`;
        out_obj[name] = (state, val) => {
            state[`select_${op}_options`] = val;
            console.log(`MUTATIONS => ${name}:${val}`)
        }
    })
    return out_obj
}()

// mutations

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/select_options_store.js